import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges } from '@angular/core';

import { TiimeAutocompleteModule, TiimeTagModule } from 'tiime-material';

import { AutocompleteWithFavoritesBase } from '@bases/autocomplete/autocomplete-with-favorites.base';
import { Offer } from '@models/offer';
import { FavoriteModelOfferService } from '@services/favorite-model-offer.service';
import { FavoriteIconButtonComponent } from '@shared-components/favorite-icon-button/favorite-icon-button.component';
import { IncludesPipe } from '@shared-pipes/includes/includes.pipe';

@Component({
  standalone: true,
  selector: 'app-offer-autocomplete',
  templateUrl: './offer-autocomplete.component.html',
  styleUrls: ['./offer-autocomplete.component.scss'],
  exportAs: 'OfferAutocomplete',
  imports: [TiimeAutocompleteModule, TiimeTagModule, FavoriteIconButtonComponent, IncludesPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferAutocompleteComponent extends AutocompleteWithFavoritesBase<Offer> implements OnChanges {
  constructor(favoriteModelOfferService: FavoriteModelOfferService) {
    super(favoriteModelOfferService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.data = this.data?.length ? this.sortDataByFavorites(this.data) : [];
    }
  }

  private sortDataByFavorites(data: Offer[]): Offer[] {
    const favoritesIds = this.favoriteService.favorites();
    const favoritesData = data.filter((offer: Offer) => favoritesIds.includes(offer.id));
    const notFavoritesData = data.filter((offer: Offer) => !favoritesIds.includes(offer.id));

    return [...favoritesData, ...notFavoritesData];
  }
}
